export const ELC_FORMS = [
  {
    section: "Client Details",
    fields: [
      { label: "Client Name", name: "accountName" },
      { label: "Address Line 1", name: "addressLine1" },
      { label: "Address Line 2", name: "addressLine2" },
      { label: "Country", name: "addressCountry" },
      { label: "City", name: "addressCity" },
      { label: "Postal Code", name: "addressPostalCode" },
      {
        label: "Client Name (Buyer Organisation)",
        name: "clientName(buyerOrganisation)",
      },
    ],
  },
  {
    section: "Job Details",
    fields: [
      { label: "Job Title", name: "jobTitle" },
      { label: "Job Type", name: "jobType" },
      { label: "BGC Category", name: "bgcCategory*" },
      { label: "Joining Date", name: "joiningDate*" },
      { label: "Avensys Notice Period", name: "avensysNoticePeriod*" },
      { label: "ECAS (ifApplicable)", name: "ecas(ifApplicable)" },
    ],
  },
  {
    section: "Candidate Details",
    fields: [
      { label: "First Name", name: "firstName" },
      { label: "Last Name", name: "lastName" },
      {
        label: "Candidate's NRIC/FIN/PP number",
        name: "candidate'sNric/fin/ppNumber*",
      },
      { label: "Date of Birth", name: "dateOfBirth*" },
      { label: "Marital Status", name: "maritalStatus*" },
      { label: "Candidate Nationality", name: "candidateNationality" },
      { label: "Current Location", name: "currentLocation" },
    ],
  },
  {
    section: "Pass Details",
    fields: [
      { label: "Pass Application", name: "passApplication" },
      { label: "Vendor", name: "vendor" },
      {
        label: "If Other Vendors, Specify Here",
        name: "ifOtherVendors,SpecifyHere",
      },
      {
        label: "Trigger EP/LOC/Spass Request",
        name: "triggerEp/loc/spassRequest",
      },
      { label: "Trigger DP Request", name: "triggerDpRequest" },
    ],
  },
  {
    section: "Benefits",
    fields: [{ label: "Benefits", name: "benefits" }],
  },
  {
    section: "Commercials",
    fields: [
      { label: "Client Bill Rate", name: "billRate" },
      { label: "Margin", name: "margin" },
      { label: "End of Contract", name: "endOfContract*" },
      { label: "Contract Duration", name: "contractDuration*" },
    ],
  },
];
